import { PlayerPosition } from "@shared/lib/database/enum.types";

export default function (position: PlayerPosition) {
  switch (position) {
    case "1":
      return "Point guard";
    case "2":
      return "Shooting guard";
    case "3":
      return "Small forward";
    case "4":
      return "Power forward";
    case "5":
      return "Center";
  }
}
